import { Component, OnInit } from '@angular/core';
import { AqarService } from 'src/app/services/aqar/aqar.service';

@Component({
  selector: 'app-aqar23-c3-three-two-two',
  templateUrl: './aqar23-c3-three-two-two.component.html',
  styleUrls: ['./aqar23-c3-three-two-two.component.scss']
})
export class Aqar23C3ThreeTwoTwoComponent implements OnInit {
  session: { title: string, link: string }[] = [];
  constructor(private service: AqarService) {
  }

  ngOnInit(): void {
    this.session = this.service.getC322();
  }
}
